import React from 'react';
import PropTypes from 'prop-types';
import { useAutoPageTracking } from '@PetSureAustralia/petsure-react-ui-library/distLib/hooks';
import { BaseCSP } from './baseCSP';
import { BrandContextProvider } from '../../contextProviders/brandContextProvider';
import { handleTracking } from '../../services/gtmService/tracking';

export { handleTracking };

const launcherPropTypes = {
  env: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  brandConfig: PropTypes.any,
  useMocks: PropTypes.bool,
  showBrandSwitch: PropTypes.bool
};

export const BaseCSPWrapper = ({ env, brandConfig, useMocks = false, showBrandSwitch }) => {
  useAutoPageTracking({ trackingFunction: handleTracking });

  return (
    <BrandContextProvider
      env={env}
      useMocks={useMocks}
      brandConfig={brandConfig}
      showBrandSwitch={showBrandSwitch}
    >
      <BaseCSP
        env={env}
        brandConfig={brandConfig}
        showBrandSwitch={showBrandSwitch}
      />
    </BrandContextProvider>
  );
};

BaseCSPWrapper.propTypes = launcherPropTypes;

export const BaseCSPLauncher = ({ env, brandConfig, useMocks = false, showBrandSwitch }) => {
  return (
    <BaseCSPWrapper
      env={env}
      brandConfig={brandConfig}
      useMocks={useMocks}
      showBrandSwitch={showBrandSwitch}
    />
  );
};

BaseCSPLauncher.propTypes = launcherPropTypes;
